import { Analytics } from 'analytics';
import consola from 'consola';
import googleAnalytics from '@analytics/google-analytics';
import mixpanel from '@analytics/mixpanel';

const logger = consola.withScope('vue-analytics');
const isProduction = process.env.NODE_ENV === 'production';

function getOptions(googleAnalyticsGa4Id, mixpanelToken, mixpanelHost) {
  return {
    app: 'proxify-careers',
    debug: !isProduction,
    settings: {
      useParams: true,
    },
    plugins: [
      googleAnalytics({
        measurementIds: [googleAnalyticsGa4Id],
        gtagConfig: {
          debug_mode: !isProduction,
        },
        autoTrack: true,
        debug: !isProduction,
      }),
      mixpanel({
        token: mixpanelToken,
        pageEvent: 'Page Viewed',
        options: {
          api_host: mixpanelHost || 'https://api-eu.mixpanel.com',
          debug: !isProduction,
        },
      }),
    ],
  };
}

export default defineNuxtPlugin((nuxtApp) => {
  const { googleAnalyticsGa4Id, mixpanelToken, mixpanelHost } =
    useRuntimeConfig().public;
  const analyticsClient = Analytics(
    getOptions(googleAnalyticsGa4Id, mixpanelToken, mixpanelHost)
  );

  if (!isProduction) {
    analyticsClient.ready((payload) => {
      logger.success('all plugins have loaded or were skipped', payload);
    });
  }

  const router = useRouter();

  nuxtApp.provide('analytics', analyticsClient);

  try {
    router.afterEach(() => {
      analyticsClient.page(
        {},
        {
          plugins: {
            all: false,
            googleAnalytics: true,
          },
        }
      );
    });
    if (!isProduction) logger.success('✔ Vue-analytics router is enabled');
  } catch (error) {
    logger.error(`Vue-analytics router is disabled (${error})`);
  }
});
